// 标绘颜色
export const iconColorFunc = (style, type) => {
  // 目前只有这些类型需要从materialOptions中取color
  const list = [
    "solidLine",
    "dashedLine",
    "arrowLine",
    "flowingLine",
    "dynamicArrowLine",
    "devetailArrowLine",
    "polygon",
    "circle",
    "curve",
    "sphere",
  ];
  if (list.find((item) => item === type)) {
    return style?.materialOptions?.color;
  } else {
    return style?.color;
  }
};

// outLine
export const outLineFunc = (style, type) => {
  // 目前只处理了文本类型是返回style
  if (
    type == "text" ||
    type == "rectangle" ||
    type == "circle" ||
    type == "dot"
  ) {
    return style;
  } else {
    return style.label;
  }
};

// 返回style还是返回style的label
export const styleOrLabel = (style, type) => {
  // 目前只处理了文本类型是返回style
  if (type == "text") {
    return style;
  } else {
    return style.label;
  }
};

// 返回materialOptions
export const materialOptionsFunc = (style, type, field) => {
  if (
    type == "text" ||
    type == "dot" ||
    type == "devetailArrowLine" ||
    type == "rectangle" ||
    (type == "circle" && !field) ||
    (type == "polygon" && !field)
  ) {
    return style;
  } else {
    return style?.materialOptions;
  }
};

export const specialLineMaterial = (style) => {
  if (style?.materialOptions?.tag) {
    return style.materialOptions.tag;
  } else {
    return style?.materialType;
  }
};
